import type { StepStatus } from "../types/runs";

/**
 * #1231: the one rule for the status a force-reset run lands in, so the run page, the Runs list,
 * the Overview counts and the connection status (#1014) read one outcome for it.
 *
 * A force reset cancels every step that was still pending or running (`RunService.forceReset`)
 * and stops no container. The run then reads what its steps read:
 *
 * - `failed` when a step had already failed on its own before the reset: that failure is real,
 *   and the steps say so (one reads Failed);
 * - `cancelled` otherwise: every step that did not finish reads Cancelled, so the run does too.
 *   It used to read Failed here, while every step read Cancelled and the Overview counted runs
 *   cancelled the ordinary way as Cancelled.
 *
 * Instance 0038 moved the force-reset runs written before this rule onto it.
 */
export function forceResetRunStatus(stepStatuses: readonly StepStatus[]): "failed" | "cancelled" {
  return stepStatuses.includes("failed") ? "failed" : "cancelled";
}

/**
 * The prefix `RunService.forceReset` writes into the `error` of every step it cancels. No other
 * writer uses it (`cancel` writes "Cancelled by an operator"), which is what lets a retry
 * recognise a force reset from the step rows alone, in the window before the `RUN_FORCE_RESET`
 * event is written, and lets Reliability count only the steps the reset itself stopped (#1229).
 */
export const FORCE_RESET_ERROR_PREFIX = "Force reset: ";
